<template>
    <div class="video_wrapper">
        <div class="video">
            <video muted controls loop autoplay :src="relatedVideo">
                <source src="https://chub.timesmedia.com.cn/a2ad61aavodtranssh1500034435/6c40b0d31397757896961115036/v.f100040.mp4" type="video/mp4">
                您的浏览器不支持 video 标签。
            </video>

        </div>
        <div class="remark">
            <div>
                <div class="title">金融聚力 智造向新</div>
                <div class="content">2024影响力·时代峰会预热片</div>
            </div>
            <span class="time">2024.11.22</span>
        </div>
        <!-- <video></video> -->
    </div>
</template>

<script>

export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.video_wrapper {
    height: 402px;
    width: 100%;
    display: flex;

    .video {
        flex-grow: 1;
        background: rgba(0, 0, 0, 0.2);

        video {
            width: 100%;
            height: 100%;
        }
    }

    .remark {
        width: 292px;
        height: 400px;
        background-image: url(~@/assets/img/jinju-2024/bg_title_video@2x.png);
        background-position: center;
        background-size: cover;
        padding: 53px 5px 31px 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #FFFFFF;
        margin-bottom: 11px;
    }

    .content {
        font-family: Source Han Sans CN;
        font-weight: 300;
        font-size: 14px;
        color: #FFFFFF;
    }

    .time {
        font-family: Public Sans;
        font-weight: 200;
        font-size: 14px;
        color: #FFFFFF;
    }
}
</style>
